module.exports = __webpack_public_path__ + "2b29627c25c1154226d27876876299f9.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/faction_campaign_3-660.jpg
// module id = 304
// module chunks = 0